module.exports = __webpack_public_path__ + "static/media/08.b792f70b.jpg";